import React from 'react';
import { ElectronWindows, ElectronWindowsContext } from './electron-windows-context';

export function useElectronWindows(): ElectronWindows {
    const electronWindows = React.useContext(ElectronWindowsContext);
    if (!electronWindows) {
        throw new Error('Unexpectedly did not find electron windows on context.');
    }
    return electronWindows;
}
